import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { VerticalDetailsGroupViewModel } from '../../../ViewModels/VerticalDetailsGroupViewModel';
import { VerticalDetailsItem } from './VerticalDetailsItem';
import ArrowDown from '@styles/webdesktop/Icons/arrowDown.svg';
export class VerticalDetailsGroup extends WMComponent {
    constructor(props) {
        super(props, (VerticalDetailsGroupViewModel));
        this.clickHeader = this.clickHeader.bind(this);
    }
    clickHeader() {
        this.viewModel.changeStateCollapse();
    }
    render() {
        const { groupName, isOpen, visibleGroup, rowItems } = this.state;
        if (!visibleGroup)
            return null;
        const { accountDetailsItemDown, accountDetailsItemMove, accountDetailsItemUp } = this.props;
        return (_jsxs("div", { className: "account-details-group", children: [_jsxs("div", { className: `header-group-container ${!isOpen ? 'collapse' : ''}`, onClick: this.clickHeader, children: [_jsx("div", { className: "group-icon-arrow", children: _jsx(ArrowDown, {}) }), _jsx("div", { className: "group-name", children: groupName })] }), isOpen && (_jsx("div", { className: "body-group-container", children: rowItems.map((row, i) => (_jsx(VerticalDetailsItem, { row: row, accountDetailsItemDown: accountDetailsItemDown, accountDetailsItemMove: accountDetailsItemMove, accountDetailsItemUp: accountDetailsItemUp }, row.getItemId()))) }))] }));
    }
}
